import { supportQueryKeys as e } from "./supportQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { supportApi as n } from "@maat/api-main";
//#region src/support/useAwaitTicketConversation.ts
var r = 1500, i = (i) => {
	let a = t({
		queryKey: e.ticket(i),
		queryFn: () => n.getTicket(i),
		enabled: !!i,
		refetchInterval: (e) => e.state.data?.ticket.conversation_id ? !1 : r
	});
	return {
		...a,
		conversationId: a.data?.ticket.conversation_id ?? null
	};
};
//#endregion
export { i as useAwaitTicketConversation };
